import React from 'react';
import { Link } from 'react-router-dom';

import { Title } from 'components/Misc/Typography';

const Final = ({ final }) => {
	return (
		<Link
			to={`/finals/${final.id}`}
			className="pt-3 px-4 pb-3 bg-white dark:bg-neutral-800 rounded-lg hover:ring focus:ring ring-amber-500 cursor-pointer transition-all"
		>
			<Title title={final.title} />
		</Link>
	);
};

export default Final;
